import React from 'react';
import { styled } from '@mui/material/styles';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TripLegPackageRejectReason } from '../../../data/models/trip-leg-package-reject-reason.model';

const PREFIX = 'TripPackageRejectDialog';

const classes = {
  uploadButton: `${PREFIX}-uploadButton`,
  list: `${PREFIX}-list`,
};

const StyledDialog = styled(Dialog)(({ theme }) => ({
  [`& .${classes.uploadButton}`]: {
    marginBottom: theme.spacing(1),
  },

  [`& .${classes.list}`]: {
    marginTop: theme.spacing(2),
    width: '100%',
  },
}));

interface TripPackageRejectDialogProps {
  rejectReasons: TripLegPackageRejectReason[];
  open: boolean;
  close: (reason?: string) => void;
}

export default function TripPackageRejectDialog({
  rejectReasons,
  open,
  close,
}: TripPackageRejectDialogProps) {
  const { t } = useTranslation('common');

  const [rejectReason, setRejectReason] = React.useState<string>('');

  const cancel = () => {
    close();
  };

  const changeReason = (evt: any) => {
    setRejectReason(evt.target.value);
  };

  const rejectTripPackage = () => {
    close(rejectReason);
  };

  return (
    <StyledDialog open={open} maxWidth="sm" fullWidth={true} scroll="body">
      <DialogTitle>{t('notification.tripPackageRejectTitle')}</DialogTitle>
      <DialogContent>
        {t('notification.tripPackageRejectMessage')}
        <div>
          <TextField
            select
            required={true}
            label={t('notification.rejectReason')}
            value={rejectReason}
            variant="filled"
            className={classes.list}
            onChange={changeReason}>
            {rejectReasons.map((reason) => {
              return (
                <MenuItem
                  value={reason['tripLegPackageRejectReasonBC']}
                  key={reason['tripLegPackageRejectReasonBC']}>
                  {reason['tripLegPackageRejectReasonName']}
                </MenuItem>
              );
            })}
          </TextField>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          variant="contained"
          onClick={rejectTripPackage}
          disabled={!rejectReason}>
          {t('common.ok')}
        </Button>
        <Button color="secondary" variant="contained" onClick={cancel}>
          {t('common.cancel')}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
}
